var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "container connect" }, [
      _c("div", { staticClass: "connect__head" }, [
        _c("h2", { staticClass: "connect__header heading-secondary" }, [
          _vm._v("\n                " + _vm._s(_vm.title) + "\n            "),
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "connect__header-title",
          domProps: { innerHTML: _vm._s(_vm.text) },
        }),
      ]),
      _vm._v(" "),
      _vm.videoPlayer
        ? _c(
            "div",
            { staticClass: "connect__video-container" },
            [
              _c("VideoPlayer", {
                attrs: {
                  link: _vm.videoPlayer.src,
                  isOnlyPreview: true,
                  preview: _vm.videoPlayer.preview,
                  alt: _vm.videoPlayer.alt,
                  theme: "rounded",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSlotUsed
        ? _c("div", { staticClass: "connect__steps-new" }, [
            _c("div", { staticClass: "connect__steps-new-item" }, [
              _c("p", [_vm._t("step1")], 2),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "connect__steps-new-item" }, [
              _c("p", [_vm._t("step2")], 2),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "connect__steps-new-item" }, [
              _c("p", [_vm._t("step3")], 2),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.steps && !_vm.isSlotUsed
        ? _c("div", { staticClass: "connect__steps-new" }, [
            _c("div", { staticClass: "connect__steps-new-item" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.steps[0]) } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "connect__steps-new-item" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.steps[1]) } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "connect__steps-new-item" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.steps[2]) } }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSlotUsed
        ? _c("p", { staticClass: "connect__p" }, [_vm._t("text")], 2)
        : _c("p", {
            staticClass: "connect__p",
            domProps: { innerHTML: _vm._s(_vm.text) },
          }),
      _vm._v(" "),
      _vm.secondParagraph
        ? _c("p", {
            staticClass: "connect__p-second",
            domProps: { innerHTML: _vm._s(_vm.secondParagraph) },
          })
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }